import axios from 'axios';
import { BASE_URL } from '../client-config'

const axiosInstance = axios.create({ baseURL: BASE_URL });
axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong' + error)
);
export default axiosInstance;

export const setSession = (authToken) => {
  try {
    axiosInstance.defaults.headers = null;
    if (authToken) {
      axiosInstance.defaults.headers = { authorization: encodeURI(authToken) };
    }
  } catch (e) {
    console.log(e);
  }

}

export const endpoints = {
  auth: {
    generateOTP: 'v2/generateotp',
    verifyOTP: 'v2/verifyotp',
    login: 'v2/api/auth/login',
  },
  users: "v2/getusers",
  dashboard: '/v2/analytics/get-interpretation-analytics',
  trends: '/v2/analytics/get-annual-analytics',
  groupChart: '/v2/analytics/get-total-completed-group-by-expert-and-report-types',
  turnAroundTime: 'v2/analytics/avg-turn-around-time',
  expertAnalysisTime: 'v2/analytics/expert-wise-turn-around-time',
  reports: {
    list: 'v2/ecg/get-list',
    details: '/api/report/details',
    latest: '/api/report/latest',
    search: '/api/report/search',
    getInterpretationStatus: '/v2/ecg/interpretation-status/',
    getlistreplica: 'v2/ecg/get-list-replica',
    // downloadPrescription: 'v2/ecg/download-prescription/',
    downloadReportOrPrescription: 'v2/ecg/download/',
  },
  center: "/v2/ecg/get-center-info",
  loginProcess: {
    usersLogin: 'v2/user/login',
    otpVerify: 'v2/user/verify',
    verifyToken: 'v2/user/verify-token',
    tester: 'v2/user/tester',
    generateFcmToken: 'v2/user/save-push-token',
    deleteFcmToken: 'v2/user/logout'
  },
  interpretation: {
    requestInterpretation: 'v2/ecg/request-for-interpretation',
    revokeInterpretationRequest: 'v2/ecg/revoke-interpretation-request',
    saveDataInterpretation: 'v2/ecg/save-interpretation-data',
    careLogAiInterpretation: 'v2/ecg/careLog-ai-interpretation',
    getPrescription: 'v2/ecg/prescription/',
    LeadTraceMatrix: 'v2/ecg/lead-trace-quality',
    reportData: 'v2/ecg/collections/',
    saveDataInterpretationReplica: 'v2/ecg/save-interpretation-data-replica',

  },
  data: {
    getEcgData: 'v2/ecg/get-ecg-data/',
    getEcgReportAndData: 'v2/ecg/download-ecg-report/',
    downloadLeadFile: 'v2/ecg/downloadLeadFile'
  },
  testdata: {
    getMonthlyData: 'v2/device/device-tests',
    getDataPercentage: 'v2/device/device-test-percentages',
    getTestCount: 'v2/device/monthly-test-counts',
  },
  device: {
    getDevice: 'v2/device',
    getReports: 'v2/device/list/',
    report: 'v2/device/download',
    disableEnable: 'v2/device/disable-enable/'
  },
  user: {
    getSpecificInvoiceData: 'v2/ecg/get-specific-invoice-data',
    getB2Busers: '/v2/user/get-b2b-users',
    saveB2BProfile: 'v2/user/save-b2b-profile',
    getB2BAssociatedUser: 'v2/user/get-associated-users',
    addB2BAssociatedUser: 'v2/user/add-associated-users',
    removeB2BAssociatedUser: 'v2/user/remove-associated-users',
    getInternalUsers: 'v2/user/get-users',
    saveInternalUsers: 'v2/user/save-users',
    removeInternalUsers: 'v2/user/remove-users',
    updateUserProfile: 'v2/user/update-profile',
    getUserOrder: 'v2/user/get-order',
    getInvoicePdf: 'v2/user/invoice',
    saveInvoiceDetails: 'v2/user/save-invoice-details',
    fetchInvoiceData: 'v2/user/fetch-invoice-data',
    toCheckInvoiceNumber: 'v2/user/check-invoice-number',
    fetchClientPdf: 'v2/user/fetch-client-pdf',
    addB2BAdmin: 'v2/user/add-b2b-admins',
    removeb2badminusers: 'v2/user/remove-b2b-admin-users',
    getB2Badmindata: 'v2/user/get-b2b-admin-users',
    getAppOnboardedUsers: 'v2/user/get-app-onboarded-users',
    getGuestUsers: '/v2/user/get-guest-users',
    getSubscriptionPlan: 'v2/analytics/get-spandan-subscription-plans',
    getMyClinics: 'v2/analytics/get_all_my_clinics_from_firebase',
    getExisitingPlanUsers: 'v2/analytics/get_all_active_spandan_subscriptions',
    getExtendExisitingPlanUsers: 'v2/analytics/get-plans-subscription',
    downloadLeadFile: 'v2/ecg/downloadLeadFile',
    getB2BAssociatedUserCount: 'v2/analytics/get-all-associated-users-test',
    getExtendPlan: 'v2/analytics/extend-plans-subscription',
    addPatient: 'v2/user/add-patient',
    removePatient: 'v2/user/remove-patient',
    getPatient: 'v2/user/get-patient',
    addSignature: 'v2/user/upload-signature',
    getSingatureList: 'v2/user/signatures',
    deleteSignature: 'v2/user/signatures/',
    updateSignature: 'v2/user/signatures/',

  },
  profile: {
    getSpecificInvoiceData: 'v2/ecg/get-specific-invoice-data',
  },
};

export const fetcher = async (args) => {
  // const [url, config] = Array.isArray(args) ? args : [args];
  // const pathParams = config.pathparams ? `${config.pathparams}` : '';
  // const queryParams = config.params ? `?${new URLSearchParams(config.params).toString()}` : '';
  // const URL = `${url.url}${pathParams}${queryParams}`;
  // const res = await axiosInstance.get(URL, { headers: generateAuth(config) });

  const [url, config] = Array.isArray(args) ? args : [args];
  const res = await axiosInstance.get(url, { ...config });
  return res.data;
};


export const poster = async (args) => {

  // const [req, config] = Array.isArray(args) ? args : [args];
  // const res = await axiosInstance.post(req.url, req.body, { headers: generateAuth(config) });

  const [url, config] = Array.isArray(args) ? args : [args];
  const res = await axiosInstance.post(url, { ...config });


  return res.data;
};

export const formPoster = async (args) => {
  const [url, formData, headers] = Array.isArray(args) ? args : [args];
  const res = await axiosInstance.post(url, formData, {
    ...(headers ? { headers } : {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  });
  return res.data;
};

export const patcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];
  const res = await axiosInstance.patch(url, { ...config });
  return res.data;
};

// function generateAuth(data) {
//   let tokenDetails = localStorage.getItem('TokenDetails');
//   if(tokenDetails){
//     tokenDetails = JSON.parse(tokenDetails);
//   }
//   return tokenDetails||{};
// }
